<template>
  <section id="formulario" class="bg-[radial-gradient(ellipse_at_center,#0d9488_0%,#0b766c_100%)] p-6 plex-regular">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700"
      @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto max-w-7xl bg-white bg-opacity-85 rounded-lg p-6">

        <div class="w-full py-6 text-center">
          <h1 class="plex-semibold text-3xl text-gray-800">ESTUDIANTES</h1>
          <h1 class="plex-semibold text-xl text-gray-800">Pre-acreditate a BIMM 2026</h1>
          <h1 class="plex-semibold text-xl text-gray-800">El motor de la industria metalmecánica</h1>
          <br/>
          <h1 class="text-md md:text-xl text-gray-800">28, 29 y 30 de mayo</h1>
          <h1 class="text-md md:text-xl text-gray-800">Jueves y Viernes de 11:00 a 19:00 hs, Sábado de 10:00 a 18:00 hs</h1>
          <h1 class="text-md md:text-xl text-gray-800">Centro de eventos Forja, Ciudad de Córdoba</h1>
          <br/>

          <h1 class="plex-semibold text-gray-800">Por favor complete el formulario en su totalidad</h1>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">DNI</label>
            <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
              <InputText v-bind="field" type="numeric" @blur="validarDni" placeholder="DNI" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" placeholder="Nombre" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" placeholder="Apellido" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">E-mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text" placeholder="E-mail" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-5/12">
            <label class="block mb-1">Confirme su E-mail</label>
            <Field name="mailConfirmacion" v-slot="{ field, errors }" v-model="formData.mailConfirmacion">
              <InputText v-bind="field" type="text" placeholder="Confirme su E-mail" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mailConfirmacion" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Fecha de nacimiento</label>
            <Field name="fechaNacimiento" v-slot="{ field, errors }" v-model="formData.fechaNacimiento">
              <InputMask v-bind="field" mask="99/99/9999" placeholder="dd/mm/yyyy" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="fechaNacimiento" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">País (Teléfono)</label>
            <Select v-model="selectedCountry" filter :options="paises" optionLabel="descripcion" placeholder="Select a Country" class="input-base input-success" />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.id" class="input-base input-success" readonly />
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text" placeholder="Teléfono celular" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>        

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Institución</label>
            <Field name="institucion" v-slot="{ field, errors }" v-model="formData.institucion">
              <InputText v-bind="field" type="text" placeholder="Institución" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="institucion" /></span>
            </Field>
          </div>          
        </div>

        <div class="w-full my-6 py-2 px-4 bg-[#25847A] text-white rounded-lg">
          <h1 class="plex-semibold text-lg">OTROS DATOS</h1>
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Seleccione los sectores de interés</label>
            <Field name="sectoresInteres" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.sectoresInteres">
              <MultiSelect @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione los sectores de interés" class="input-base" :options="sectores" optionLabel="descripcion" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="sectoresInteres" /></span>
            </Field>
          </div>
        </div>
        
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">¿Cómo conoció BIMM?</label>
            <Field name="tipoContacto" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tipoContacto">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccione como nos conoció" :options="tiposContactos" optionLabel="descripcion" class="input-base" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoContacto" /></span>
            </Field>
          </div>
        </div>


        <div class="w-full mx-auto font-chevy-regular space-y-5 mt-3">
          <div class="flex flex-wrap -mx-2 space-y-4">
            <div class="w-full px-2  space-x-2">
              <Field name="aceptoNoMenores" v-slot="{ handleChange, handleBlur, value }" v-model="formData.aceptoNoMenores">
                <Checkbox :checked="value" @update:model-value="handleChange" @blur="handleBlur" size="large" inputId="aceptoNoMenores" binary />
                <label for="aceptoNoMenores" class="cursor-pointer">Acepto no asistir con menores de 16 años al evento.</label>
                <span class="text-sm text-red-500 p-error"><br/><ErrorMessage name="aceptoNoMenores" /></span>
              </Field>
            </div>
          </div>
        </div>
        
        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>
    </Form>

  </section>

  <FullScreenLoader :visible="isSubmitting" fullScreen />

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import InputMask from 'primevue/inputmask';
import MultiSelect from 'primevue/multiselect';
import Checkbox from 'primevue/checkbox';

import jsonCountries from '@/data/countries.json';
import jsonSectoresInteres from '@/data/sectoresInteres.json';
import jsonTiposContacto from '@/data/tiposContacto.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, OrigenAcreditado, StringIdLabelEntity } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';
import { SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";

import FullScreenLoader from '@/components/FullScreenLoader.vue';

interface Pais extends StringIdLabelEntity { }
interface SectorInteres extends StringIdLabelEntity { }
interface TipoContacto extends StringIdLabelEntity { }

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Select, InputMask, MultiSelect, Checkbox,
    Field, ErrorMessage, Form,
    FullScreenLoader
  },
  data() {
    return {
      paises: jsonCountries as Pais[],
      tiposContactos: jsonTiposContacto as TipoContacto[],
      sectores: jsonSectoresInteres as SectorInteres[],
      selectedCountry: { "id": "+54", "descripcion": "Argentina" } as Pais,
      isSubmitting: false,
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        mail: '',
        mailConfirmacion: '',
        telefonoCelular: '',
        fechaNacimiento: '',
        institucion: '',
        sectoresInteres: undefined as unknown as SectorInteres[],
        tipoContacto: undefined as unknown as TipoContacto,
        aceptoNoMenores: false,        
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required('Ingrese el DNI').min(8, 'Al menos 8 números'),
        nombre: yup.string().required('Ingrese el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese el apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
        mailConfirmacion: yup.string().required('Ingrese el correo').email('Correo inválido').oneOf([yup.ref('mail')], 'Los correos no coinciden'),
        fechaNacimiento: yup.string().required("Ingrese la fecha").matches(/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/, "Fecha inválida, se espera dd/mm/yyyy"),
        telefonoCelular: yup.string().required('Ingrese el celular').matches(/^\d+$/, 'Solo se permiten números'),
        sectoresInteres : yup.mixed().required('Seleccione al menos un sector de interés'),
        tipoContacto: yup.mixed().required('Seleccione como nos conoció'),
      });
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      console.log(values);

      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: "Revise el formulario<br>Hay " + errores + " error/es", icon: "error" });
    },
    async validarDni() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni="+this.formData.dni) as Acreditado;
        if (acreditadoExistente) {
          this.isSubmitting = false;
          Swal.fire({ title: "Atención", html: "El DNI ingresado ya fue registrado.<br/><br/>Le enviamos un mail para informarle el estado de su registración. <br/><br/>Por favor revise su casilla de correo y de spam.", icon: "warning" });
          return;
        }
      } catch(error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },    
    async onSubmit() {
      let acreditadoExistente: Acreditado[] = await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni=" + encodeURIComponent(this.formData.dni));
      if (acreditadoExistente.length > 0) {
        this.isSubmitting = false;
        Swal.fire({ title: "Atención", html: "¡Ya se acreditó con este DNI!<br/><br/>Le enviamos un correo con su credencial digital<br/><br/>Si no le llega el correo puede descargar la credencial usando el botón <b>'YA ME ACREDITE'</b> de esta página.", icon: "info" }).then(() => {
          this.isSubmitting = false;
        });
        return;
      }

      if (!this.formData.aceptoNoMenores) {
        Swal.fire({ title: "Atención", html: "¡Debe aceptar que no asistirá con menores de 16 años al evento!", icon: "error" }).then(() => {
          this.isSubmitting = false;
        });
        return;        
      }

      this.isSubmitting = true;

      let acreditado: Acreditado = new Object() as Acreditado;
      acreditado.tipoAcreditado = { "id": 2444 } as TipoAcreditado;
      acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
      acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
      acreditado.dni = this.formData.dni;
      acreditado.nombre = this.formData.nombre;
      acreditado.apellido = this.formData.apellido;
      acreditado.telefono = this.selectedCountry.id + this.formData.telefonoCelular;
      acreditado.mail = this.formData.mail;
      acreditado.fechaNacimiento = this.formData.fechaNacimiento;
      acreditado.empresa = this.formData.institucion;

      acreditado.dato17 = this.formData.sectoresInteres.map(sector => sector.id).join(', ');
      acreditado.dato21 = this.formData.tipoContacto?.id;
      acreditado.dato20 = this.formData.aceptoNoMenores ? "SI" : "NO";

      acreditado.modificado = SAVE;
      acreditado.cantidad = 1;
      acreditado.notificar = true;      

      try {
        await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

        Swal.fire({
          title: "Acreditación exitosa",
          html: "Hemos recibido sus datos de acreditación con éxito.<br/>Le enviamos un código QR al mail indicado para agilizar su ingreso al evento. <br/><br/>Si tiene problemas para recibir el correo puede presentarse con sun DNI.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://bimm.com.ar";
        });

      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
  }
});
</script>
